<template>
  <section id="login">
    <div class="content">
      <h3>JOFPH&nbsp;&nbsp;后台管理</h3>
      <h5>用户登录</h5>
      <div class="input">
        <a-icon type="user" />
        <input type="text" placeholder="请输入账号" v-model="loginName" />
      </div>
      <div class="input">
        <a-icon type="lock" />
        <input type="password" placeholder="请输入密码" v-model="loginPass" />
      </div>
      <!-- <router-link to="/access/register">前往注册</router-link> -->
      <button v-on:click="login">立即登录</button>
    </div>
    <div class="warp" id="particle-canvas">
      <div>
        <a-carousel autoplay effect="fade">
          <div>
            <img
              src="https://oss.mrepress.net/static/login_bg/banner1.png"
              alt=""
            />
          </div>
          <div>
            <img
              src="https://oss.mrepress.net/static/login_bg/banner2.png"
              alt=""
            />
          </div>
          <div>
            <img
              src="https://oss.mrepress.net/static/login_bg/banner3.png"
              alt=""
            />
          </div>
        </a-carousel>
      </div>
    </div>
  </section>
</template>

<script>
import login from "./login.js";
export default login;
</script>

<style lang="scss" scoped>
@import "./login.scss";
</style>
